import * as React from "react";

function Youtube(props) {
  return (
    <svg
      width={20}
      height={14}
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4752_794)">
        <path
          d="M19.5822 2.18691C19.3511 1.32691 18.6756 0.649133 17.8133 0.418022C16.2533 0.000244141 10 0.000244141 10 0.000244141C10 0.000244141 3.74667 0.000244141 2.18667 0.418022C1.32667 0.649133 0.648889 1.32691 0.417778 2.18691C0 3.74691 0 7.00024 0 7.00024C0 7.00024 0 10.2536 0.417778 11.8136C0.646667 12.6736 1.32444 13.3514 2.18667 13.5825C3.74667 14.0002 10 14.0002 10 14.0002C10 14.0002 16.2533 14.0002 17.8133 13.5825C18.6733 13.3514 19.3511 12.6758 19.5822 11.8136C20 10.2536 20 7.00024 20 7.00024C20 7.00024 20 3.74691 19.5822 2.18691ZM8 10.0002V4.00024L13.1956 7.00024L8 10.0002Z"
          fill="#8A8D8F"
        />
      </g>
      <defs>
        <clipPath id="clip0_4752_794">
          <rect
            width="20"
            height="14"
            fill="white"
            transform="translate(0 0.000244141)"
          />
        </clipPath>
      </defs>
      Ï
    </svg>
  );
}

export default Youtube;
